export const copyToClipboard = (e, copyText) => {
    e?.preventDefault?.();

    if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(copyText).catch(() => {
            fallbackCopy(copyText);
        });
    } else {
        fallbackCopy(copyText);
    }
};

const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;

    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
        document.execCommand('copy');
    } catch (err) {
        console.error('Fallback: Copy failed', err);
    }

    document.body.removeChild(textarea);
};
